<div class="onboarding-home-shell">
  @if (view() === 'metadata-select') {
    <lib-model-metadata-select (selectionComplete)="onMetadataSelection($event)" />
  } @else if (view() === 'manual') {
    <lib-model-home
      [publisherRole]="publisherRole()"
      (back)="onWizardBack()"
      (complete)="onModelComplete($event)"
      (submitError)="onSubmitError($event)"
    ></lib-model-home>
  } @else if (view() === 'json-upload') {
    <lib-model-metadata-json-home
      [publisherRole]="publisherRole()"
      (back)="onWizardBack()"
      (complete)="onModelComplete($event)"
      (submitError)="onSubmitError($event)"
    ></lib-model-metadata-json-home>
  }
</div>

@if (successModalVisible()) {
  <div
    class="onboarding-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="model-onboarding-success-title"
    aria-describedby="model-onboarding-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <h2 id="model-onboarding-success-title" class="onboarding-success-modal__title">
          Metadata Information is successfully stored.
        </h2>
        <p id="model-onboarding-success-desc" class="onboarding-success-modal__status">
          Please upload the data inorder to publish the model.
        </p>
        <div class="onboarding-success-modal__actions">
          <button type="button" class="onboarding-success-modal__btn onboarding-success-modal__btn--primary" (click)="onUploadNowClick()">
            Upload now
          </button>
          <span class="onboarding-success-modal__or" aria-hidden="true">or</span>
          <button type="button" class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary" (click)="onUploadLaterClick()">
            Upload Later
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}

@if (uploadModalVisible()) {
  <div
    class="onboarding-upload-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="model-onboarding-upload-heading"
    aria-describedby="model-onboarding-upload-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-upload-modal__backdrop" aria-hidden="true" (click)="dismissUploadModal()"></div>
    <div class="onboarding-upload-modal__panel" (click)="$event.stopPropagation()">
      <header class="onboarding-upload-modal__header">
        <div class="onboarding-upload-modal__header-text">
          <h2 id="model-onboarding-upload-heading" class="onboarding-upload-modal__title">Connection Details</h2>
          <p id="model-onboarding-upload-desc" class="onboarding-upload-modal__lede">
            @if (uploadModalDataSourceUrlEnabled()) {
              Upload files directly or connect a <strong>Data Source URL</strong> to fetch data automatically.
            } @else {
              Upload files directly to add data to this model.
            }
          </p>
        </div>
        <button
          type="button"
          class="onboarding-upload-modal__close"
          (click)="onUploadModalPrevious()"
          aria-label="Go back to previous step"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </header>
      <div class="onboarding-upload-modal__body">
        <lib-ngsild-upload-files
          layout="modal"
          resourceServer="file-server"
          assetKind="model"
          [fileFormat]="uploadModalFileFormat()"
          [modalDatasetLabel]="uploadModalModelLabel()"
          [itemId]="modelCreatedItemId()"
          [onboardingPayload]="modelLastPayload()?.payload ?? null"
          (modalDismiss)="dismissUploadModal()"
          (modalPrevious)="onUploadModalPrevious()"
          (publishSuccess)="onUploadPublishSuccess()"
        />
      </div>
    </div>
  </div>
}

@if (publishSuccessModalVisible()) {
  <div
    class="onboarding-success-modal onboarding-publish-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="model-publish-success-title"
    aria-describedby="model-publish-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <div class="onboarding-publish-success-modal__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#16a34a" stroke-width="2" />
            <path d="M9 12l2 2 4-4" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 id="model-publish-success-title" class="onboarding-success-modal__title">
          {{ publishSuccessTitle() }}
        </h2>
        <p id="model-publish-success-desc" class="onboarding-publish-success-modal__message">
          {{ publishSuccessMessage() }}
        </p>
        <div class="onboarding-success-modal__actions onboarding-success-modal__actions--row">
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary"
            (click)="onPublishCreateNew()"
          >
            Create New
          </button>
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--primary"
            [disabled]="!modelCreatedItemId()"
            (click)="onPublishViewModel()"
          >
            View Model
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}
